import React from 'react'
import {Pie, PieChart, Tooltip} from 'recharts'
import {Rental} from '../../../common/types/rental'
import {BoxForStats} from '../types/BoxForStats'
import {generateRentalsPerBoxPieData, RentalsPerBoxPieData} from './utils/generateRentalsPerBoxPieData'

interface Props {
  boxes: BoxForStats[]
  isPublic?: boolean
  rentals: Rental[]
}

export const RentalsPerBoxPie: React.FC<Props> = ({boxes, isPublic = false, rentals}) => {
  return (
    <PieChart width={600} height={600}>
      <Pie
        data={generateRentalsPerBoxPieData(boxes as any, rentals)}
        dataKey="count"
        label={(data: RentalsPerBoxPieData) => (data.count >= 1 ? data.box : undefined)}
        nameKey="box"
        cx="50%"
        cy="50%"
        outerRadius={100}
        fill="#B40A7A"
      />
      <Tooltip formatter={(_, __, props) => (isPublic ? `${props.payload.share}%` : `${props.payload.count} (${props.payload.share}%)`)} />
    </PieChart>
  )
}
